import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import { Home as HomeIcon } from "@mui/icons-material";
import { AddButton } from "~/components/add-button";
import { Link as RouterLink } from "react-router-dom";
import { Flex } from "~/components/Flex";
import { CreateOrganization } from "~/pages/space/workspaces/components/CreateOrganization";

export function CreateOrganizationPage() {
  const breadcrumbs = [
    <Link
      key="/dashboard"
      component={RouterLink}
      to={`/dashboard`}
      display="flex"
    >
      <HomeIcon fontSize="inherit" />
    </Link>,
    <Link
      key="/organizations"
      component={RouterLink}
      to={`/dashboard`}
      display="flex"
    >
      Organizations
    </Link>,
    <Typography key="/organizations/new">Create New</Typography>,
  ];

  return (
    <Box>
      <Breadcrumbs sx={{ mb: 3, overflowWrap: "anywhere" }} separator="›">
        {breadcrumbs}
      </Breadcrumbs>
      <Box
        id="create-new-organization-header"
        mb={3}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 2,
        }}
      >
        <Flex flexDirection="column">
          <Typography
            variant="h4"
            component="h1"
            fontWeight={700}
            textTransform="uppercase"
            sx={{ mb: 1 }}
          >
            Create New Organization
          </Typography>
          <Typography sx={{ color: "text.secondary" }}>
            Create a new organization to contain all the different spaces in
            your company as well as role-based access control.
          </Typography>
        </Flex>
        <Flex id="create-new-organization-actions" alignItems="center" gap={4}>
          <AddButton
            id="organization"
            href="/dashboard"
            aria-label="Create New Organization"
            close
          />
        </Flex>
      </Box>
      <CreateOrganization />
    </Box>
  );
}
